import { useNavigate } from "react-router-dom";

import { usePageBackTarget } from "../context/PageBackContext.js";
import { SpecularButton } from "./ui/specular-button.js";
import { AttendanceClock } from "./AttendanceClock.js";
import { NotificationBell } from "./notifications/NotificationBell.js";

/**
 * Shared by the clock and the bell so both panels read as one surface.
 *
 * mt-3 is what clears the 53px header: the triggers are 36px and vertically
 * centred, leaving ~8px below them, so DropdownPanel's default mt-1 would open
 * the panel inside the bar. Width and offset live together here precisely so one
 * panel cannot be corrected without the other.
 *
 * max-w keeps the panel in the space beside the sidebar on phones: right-anchored
 * at the header edge, a bare 340px would run under the sidebar and clip its left side.
 */
export const HEADER_PANEL_CLASS = "mt-3 w-[340px] max-w-[calc(100vw-7rem)]";

export function TopHeaderBar() {
  const navigate = useNavigate();
  const back = usePageBackTarget();

  return (
    <div className="sticky top-0 z-40 flex h-[var(--app-header-h)] items-center gap-2 border-b border-surface-200 bg-surface-0 px-4">
      {/* The one place a page-level Back button lives; pages register it with usePageBack. */}
      {back && (
        <SpecularButton
          onClick={() => (typeof back.to === "function" ? back.to() : navigate(back.to))}
          size="sm"
        >
          &larr; {back.label}
        </SpecularButton>
      )}

      {/* The positioning context for BOTH panels. Anchoring each one to its own
          icon would leave them ~40px apart; sharing this element means they open
          against the same right edge and read as one surface. */}
      <div className="relative ml-auto flex items-center gap-1">
        <AttendanceClock panelClassName={HEADER_PANEL_CLASS} />

        <NotificationBell />
      </div>
    </div>
  );
}
